var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMatelot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.771,
    height: 83.662,
    viewBox: "0 0 90.771 83.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yacht",
    transform: "translate(0.001 -20.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    transform: "translate(-0.001 97.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3441",
    "data-name": "Group 3441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8464",
    "data-name": "Path 8464",
    d: "M90.383,456.771a1.772,1.772,0,0,0-2.491-.282,5.2,5.2,0,0,1-6.5,0l-.026-.021a8.725,8.725,0,0,0-10.908.01,5.194,5.194,0,0,1-6.495.007l-.009-.007a8.725,8.725,0,0,0-10.908-.009l-.034.027a5.2,5.2,0,0,1-6.488,0l-.036-.029a8.728,8.728,0,0,0-10.915.016,5.2,5.2,0,0,1-6.5.005l-.034-.027a8.727,8.727,0,0,0-10.9,0l-.033.026a5.193,5.193,0,0,1-6.49,0l-.014-.011A8.725,8.725,0,0,0,.7,456.474l-.034.027a1.772,1.772,0,0,0,2.206,2.775l.033-.026a5.193,5.193,0,0,1,6.489,0l.014.011a8.724,8.724,0,0,0,10.91.008l.033-.026a5.2,5.2,0,0,1,6.491,0l.034.027a8.727,8.727,0,0,0,10.916-.015,5.2,5.2,0,0,1,6.5-.006l.036.029a8.727,8.727,0,0,0,10.9,0l.034-.027a5.2,5.2,0,0,1,6.488,0l.009.007a8.722,8.722,0,0,0,10.919,0,5.2,5.2,0,0,1,6.5,0l.026.021a8.725,8.725,0,0,0,10.907-.01A1.773,1.773,0,0,0,90.383,456.771Z",
    transform: "translate(0.001 -454.557)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444",
    transform: "translate(18.18 78.536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8465",
    "data-name": "Path 8465",
    d: "M105.576,350.472a1.772,1.772,0,1,0,.519,1.253A1.775,1.775,0,0,0,105.576,350.472Z",
    transform: "translate(-102.551 -349.953)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446",
    transform: "translate(0.026 78.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M12.627,364.18l-.025-.021a29.261,29.261,0,0,1-8.079-10.665h7.395a1.772,1.772,0,1,0,0-3.545H1.924A1.772,1.772,0,0,0,.248,352.3a32.805,32.805,0,0,0,10.091,14.59l.024.02a1.773,1.773,0,0,0,2.264-2.728Z",
    transform: "translate(-0.152 -349.95)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(25.459 20.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8467",
    "data-name": "Path 8467",
    d: "M208.589,79.278a1.773,1.773,0,0,0-1.443-.743H165.319V21.82a1.772,1.772,0,1,0-3.545,0V78.535H145.38a1.772,1.772,0,1,0,0,3.545h59.167a29.261,29.261,0,0,1-8.079,10.666l-.024.02a1.772,1.772,0,1,0,2.263,2.728l.023-.019a32.8,32.8,0,0,0,10.092-14.59A1.771,1.771,0,0,0,208.589,79.278Z",
    transform: "translate(-143.608 -20.048)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(50.715 44.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8468",
    "data-name": "Path 8468",
    d: "M289.093,155.9a1.771,1.771,0,1,0,.519,1.253A1.785,1.785,0,0,0,289.093,155.9Z",
    transform: "translate(-286.068 -155.381)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(50.715 20.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8469",
    "data-name": "Path 8469",
    d: "M309.8,44.185A63.106,63.106,0,0,0,291,21.949l-2.11-1.554a1.772,1.772,0,0,0-2.823,1.427V38.208a1.772,1.772,0,0,0,3.545,0V25.337a59.5,59.5,0,0,1,23.368,45.4H289.613V52.029a1.772,1.772,0,0,0-3.545,0V72.51a1.772,1.772,0,0,0,1.772,1.772H314.78a1.772,1.772,0,0,0,1.772-1.772A63.107,63.107,0,0,0,309.8,44.185Z",
    transform: "translate(-286.068 -20.049)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454",
    transform: "translate(14.382 29.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8470",
    "data-name": "Path 8470",
    d: "M105.484,70.612a1.772,1.772,0,0,0-1.994.889L81.336,113.234a1.773,1.773,0,0,0,1.565,2.6h22.154a1.772,1.772,0,0,0,1.772-1.772V72.332A1.772,1.772,0,0,0,105.484,70.612Zm-2.2,41.681H85.848L103.283,79.45Z",
    transform: "translate(-81.129 -70.559)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMatelot);
export default __webpack_public_path__ + "static/media/icon-matelot.e0d46360.svg";
export { ForwardRef as ReactComponent };